import PropTypes from "prop-types";

// Layouts
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import PayPlanAssignmentsLoader from "@/Layouts/components/Skeletons/PayPlanAssignmentsLoader";

// Images
import empty from "@/assets/images/commons/empty.png";
import emptyTable from "@/assets/images/commons/empty_table.png";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";

const RenderContent = (props) => {
	const { children, selected = null, filteredData = [], loading = false } = props;

	const emptyMessage = !selected ? "Select a Pay Plan." : "No employees for this Pay Plan.";

	if (loading) {
		return <PayPlanAssignmentsLoader addSelector amount={6} />;
	}

	if (!selected || !filteredData?.length) {
		return (
			<EmptyBody
				image={selected ? emptyTable : empty}
				title={emptyMessage}
				bodyHeight="510px"
				sx={{
					boxShadow: "none !important",
				}}
			/>
		);
	}

	return <>{children}</>;
};
RenderContent.propTypes = {
	children: PropTypes.node,
	selected: PropTypes.object,
	filteredData: PropTypes.array,
	loading: PropTypes.bool,
};

export default function SelectedItemContent(props) {
	return (
		<RoundedBox sx={{ minHeight: "630px" }}>
			<RenderContent {...props} />
		</RoundedBox>
	);
}
SelectedItemContent.propTypes = {
	children: PropTypes.node,
	selected: PropTypes.object,
	filteredData: PropTypes.array,
	searchValue: PropTypes.string,
	loading: PropTypes.bool,
};
